/* Sample JavaScript file added with ScriptTag resource. 
This sample file is meant to teach best practices.
Your app will load jQuery if it's not defined. 
Your app will load jQuery if jQuery is defined but is too old, e.g. < 1.7. 
Your app does not change the definition of $ or jQuery outside the app. 
Example: if a Shopify theme uses jQuery 1.4.2, both of these statements run in the console will still return '1.4.2'
once the app is installed, even if the app uses jQuery 1.9.1:
jQuery.fn.jquery => "1.4.2" 
$.fn.jquery -> "1.4.2"
*/

/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within 
aren’t available to the outside world. */

(function(){
  
    /* Load Script function we may need to load jQuery from the Google's CDN */
    /* That code is world-reknown. */
    /* One source: http://snipplr.com/view/18756/loadscript/ */
    
    var loadScript = function(url, callback){
     
      var script = document.createElement("script");
      script.type = "text/javascript";
    
      // If the browser is Internet Explorer.
      if (script.readyState){ 
        script.onreadystatechange = function(){
          if (script.readyState == "loaded" || script.readyState == "complete"){
            script.onreadystatechange = null;
            callback();
          }
        };
      // For any other browser.
      } else {
        script.onload = function(){
          callback();
        };
      }
    
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
        
    };

    function updateFiltersStickiness() {
      var scrollTop = $(document).scrollTop();
        /*
      var ref = 33;

      if (scrollTop >= ref) {
          if (!$('.collection__filter-block').hasClass('sticky')) {
            $('.collection__filter-block').addClass('sticky');

            var width = $(document).width();
            if (width < 437)
                $('.collection__filter-block').css('top', 123);
            else if (width < 750)
                $('.collection__filter-block').css('top', 88);
            else if (width < 990)
                $('.collection__filter-block').css('top', 133);
            else
                $('.collection__filter-block').css('top', '');

          }
      } else {
          if ($('.collection__filter-block').hasClass('sticky')) {
            $('.collection__filter-block').removeClass('sticky');
            if (width < 750)
                $('.collection__filter-block').css('top', 173);
            else
                $('.collection__filter-block').css('top', '');
          }
      }
      */
    }
    
    /* This is my app's JavaScript */
    var collectionJavaScript = function($){
      // $ in this scope references the jQuery object we'll use.
      // Don't use jQuery, or jQuery191, use the dollar sign.
      // Do this and do that, using $.

        $('.js-collection__filter-switch').click(function(e) {
            e.preventDefault();
            $('.collection__filters').removeClass('load-open-desktop'); // remove behaviour at loading
            if ($(this).attr('showfilters') == '1') {
                $('.collection__filters').removeClass('open');
                $('.collection-grid-with-filters').removeClass('collection-grid-with-filters--filters-open');
                $(this).text('SHOW FILTERS');
                $(this).attr('showfilters', '0');
                $('.collection__filters').one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                function(event) {
                  console.log('HAS CLOSED');
                });

            } else {
                $('.collection__filters').addClass('open');
                $('.collection-grid-with-filters').addClass('collection-grid-with-filters--filters-open');
                $(this).text('HIDE FILTERS');
                $(this).attr('showfilters', '1');
                $('.collection__filters').one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                function(event) {
                  console.log('HAS OPENED');
                });
            }
        })

        $('.js-collection__toggle-tag').click(function(e) {
            e.preventDefault();
            //$(this).parent().children(":not('.js-collection__toggle-tag')").first().trigger('click');
            console.log('HREF', $(this).parent().children(":not('.js-collection__toggle-tag')").first().attr('href'));
            document.location.href = $(this).parent().children(":not('.js-collection__toggle-tag')").first().attr('href');
        })

        // change filter switch if needed and mobile
        var isMobileWidth = ($(window).width() < 838);
        if (isMobileWidth && $('.js-collection__filter-switch').attr('showfilters') == '1') {
          $('.js-collection__filter-switch').attr('showfilters', '0');
          $('.js-collection__filter-switch').text('SHOW FILTERS');
        }

        // stick filters when needed
        $(document).on('scroll', updateFiltersStickiness);
        updateFiltersStickiness();

    };
    
    /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
    we will load jQuery from the Google CDN, and when it's fully loaded, we will run
    our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
    as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
        jQuery191 = jQuery.noConflict(true);
        collectionJavaScript(jQuery191);
      });
    } else {
        collectionJavaScript(jQuery);
    }
    
    })();